// Global packages, functions and components
import { Link } from '@remix-run/react'
import {
  Button,
  Heading,
  BannerImage,
  SchemaWrapper,
  SchemaMeta,
  SchemaElement,
} from '~/components'
import { getExcerpt, createBlogSlug } from '~/utils'

// Types
import type { BlogListingItem } from '~/types'

interface Props extends BlogListingItem {
  /**
   * BlogPosting microdata. Off where the card sits on a page whose structured
   * data is JSON-LD only, such as a product page
   */
  withSchema?: boolean
}

// Main export
const BlogListerItem = ({
  slug,
  title,
  image,
  excerpt,
  slugCategory,
  withSchema = true,
}: Props) => {
  return (
    <SchemaWrapper
      as="article"
      type={withSchema ? 'BlogPosting' : undefined}
      className="group relative block aspect-square overflow-hidden rounded-2xl"
    >
      <Link
        to={createBlogSlug({ slugCategory, slug })}
        itemProp={withSchema ? 'url' : undefined}
        className="group relative block aspect-square overflow-hidden rounded-2xl"
      >
        <div className="absolute left-0 top-0 z-[3] flex size-full flex-col items-start justify-end p-5 text-white lg:p-8">
          <Heading
            tag="h3"
            size="h5"
            className="mb-2"
          >
            {withSchema ? (
              <SchemaElement prop="headline">{title}</SchemaElement>
            ) : (
              title
            )}
          </Heading>
          <p className="mb-4">{getExcerpt(excerpt, 120)}</p>
          <Button
            title="Learn more"
            style="vibrantGreen"
            hasArrow
            mimic
          />
          {withSchema && (
            <SchemaMeta
              prop="mainEntityOfPage"
              content={createBlogSlug({ slugCategory, slug })}
            />
          )}
        </div>
        <BannerImage
          image={image}
          size={768}
          withSchema={withSchema}
        />
      </Link>
    </SchemaWrapper>
  )
}

export default BlogListerItem
